export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
                  移动畅读
                </h2>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md">
                  虫虫动漫移动端适配完美，无论是在通勤路上、午休时间还是睡前放松，打开手机即可畅享下拉式漫画滚动浏览。高清画质，流畅阅读，随时随地看你想看的免费在线漫画。
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-3 justify-center lg:justify-start">
                  <div className="flex items-center gap-2 px-4 py-2 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-pointer whitespace-nowrap">
                    <i className="ri-android-line"></i>
                    <span>Android 下载</span>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-pointer whitespace-nowrap">
                    <i className="ri-apple-line"></i>
                    <span>iOS 下载</span>
                  </div>
                </div>
                <p className="mt-3 text-xs text-foreground-400">
                  扫码下载或直接在浏览器中访问，即可畅享免费漫画阅读
                </p>
              </div>
              <div className="flex-shrink-0">
                <div className="relative w-48 h-80 bg-background-200 rounded-2xl overflow-hidden border-4 border-foreground-900/10">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20reading%20app%20interface%20on%20screen%2C%20showing%20a%20comic%20page%20with%20Japanese%20style%20artwork%2C%20clean%20UI%20design%20with%20warm%20coral%20accents%2C%20phone%20held%20in%20a%20hand%20against%20a%20warm%20neutral%20background%2C%20modern%20minimal%20design&width=400&height=700&seq=app-comic-01&orientation=portrait"
                    alt="虫虫动漫移动端阅读界面"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}